import { createStore } from 'vuex'

import * as mutationTypes from './mutation-types'
import * as communicationMutationTypes from '@app/application/communication/sections/communication/store/mutation-types'

import commentApi from '@app/application/communication/sections/communication/api/comment'

import users from '@app/application/communication/sections/communication/store/users'
import contexts from '@app/application/communication/sections/communication/store/contexts'
import attachments from '@app/application/communication/sections/communication/store/attachments'
import comments from '@app/application/communication/sections/communication/store/comments'
import ui from '@app/application/communication/sections/communication/store/ui'
import remarkTags from '@app/application/communication/sections/communication/store/remark-tags'

import notifications from './notifications'
import inboxCommunicationItems from './inbox-communication-items'
import inboxChecks from './inbox-checks'

export const actions = {
  // it overrides method from comment module
  postComment({ commit, dispatch, state }, [commentableId, type, params]) {
    const companyId =
      state.notifications.activeCompanyId || Silverfin.currentCompanyId

    return new Promise((resolve, reject) => {
      commentApi
        .postComment(commentableId, type, params, companyId)
        .then(() => {
          commit(communicationMutationTypes.REMOVE_NEW_COMMENT_REMARK_ID, {
            id: commentableId,
          })
          dispatch('fetchCommunicationItem', { id: commentableId, type })

          resolve()
        })
        .catch(reject)
    })
  },
  // it overrides method from comment module
  editComment(
    { commit, dispatch, state },
    [commentableId, type, commentId, params]
  ) {
    const companyId =
      state.notifications.activeCompanyId || Silverfin.currentCompanyId

    return new Promise((resolve, reject) => {
      commentApi
        .editComment(commentableId, type, commentId, params, companyId)
        .then(() => {
          commit(communicationMutationTypes.REMOVE_EDIT_COMMENT_ID, {
            id: commentId,
          })
          dispatch('fetchCommunicationItem', { id: commentableId, type })
          resolve()
        })
        .catch(reject)
    })
  },
}

const getters = {
  loadingNotifications: ({ loading }) => loading.notifications,
  loadingCommunicationItem: ({ loading }) => loading.communicationItem,
  loadingCompanies: ({ loading }) => loading.companies,
}

export default function createInboxStore(endpointParams) {
  return createStore({
    modules: {
      users,
      contexts,
      checks: inboxChecks,
      attachments,
      comments: { ...comments, actions: {} }, // We override those actions
      ui,
      notifications,
      remarkTags,
      inboxCommunicationItems: inboxCommunicationItems(endpointParams),
    },
    state() {
      return {
        loading: {
          notifications: false,
          companies: false,
          communicationItem: false,
        },
      }
    },
    actions,
    getters,
    mutations: {
      [mutationTypes.SET_LOADING](state, { type, value }) {
        state.loading[type] = value
      },
    },
  })
}
